import EmblaCarousel from 'embla-carousel';
import AutoHeight from 'embla-carousel-auto-height'

document.addEventListener('DOMContentLoaded', function() {

  const emblaNodes = document.querySelectorAll('.embla');

  emblaNodes.forEach(emblaNode => {

    const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector('.embla__button--next');
    const dotsNode = emblaNode.querySelector('.embla__dots');
    const controlsNode = emblaNode.querySelector('.embla__controls');

    if (!prevBtnNode || !nextBtnNode) {
      return;
    }

    const emblaOptions = emblaNode.dataset.emblaOptions ? JSON.parse(emblaNode.dataset.emblaOptions) : {};
    const emblaApi = EmblaCarousel(emblaNode, emblaOptions, [AutoHeight()]);

    let previousWatchDrag;
    emblaApi.on('slidesInView', () => {
      const watchDrag = emblaApi.scrollSnapList().length > 1;
      if (previousWatchDrag !== watchDrag) {
        emblaApi.reInit({...emblaOptions, watchDrag});
        controlsNode.style.display = watchDrag ? '' : 'none';
        previousWatchDrag = watchDrag;
      }
    });

    const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
      const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) {
          prevBtn.removeAttribute('disabled');
        } else {
          prevBtn.setAttribute('disabled', 'disabled');
        }
        if (emblaApi.canScrollNext()) {
          nextBtn.removeAttribute('disabled');
        } else {
          nextBtn.setAttribute('disabled', 'disabled');
        }
      };
      emblaApi
        .on('select', togglePrevNextBtnsState)
        .on('init', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState);
      return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
      };
    };

    const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
      const scrollPrev = () => emblaApi.scrollPrev();
      const scrollNext = () => emblaApi.scrollNext();
      prevBtn.addEventListener('click', scrollPrev, false);
      nextBtn.addEventListener('click', scrollNext, false);
      const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);
      return () => {
        removeTogglePrevNextBtnsActive();
        prevBtn.removeEventListener('click', scrollPrev, false);
        nextBtn.removeEventListener('click', scrollNext, false);
      }
    };

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

    const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
      let dotNodes = [];
      const addDotBtnsWithClickHandlers = () => {
        dotsNode.innerHTML = emblaApi
          .scrollSnapList()
          .map(() => '<button class="embla__dot" type="button"></button>')
          .join('');
        const scrollTo = index => emblaApi.scrollTo(index);
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
        dotNodes.forEach((dotNode, index) => {
          dotNode.addEventListener('click', () => scrollTo(index), false);
        });
      };
      const toggleDotBtnsActive = () => {
        dotNodes[emblaApi.previousScrollSnap()].classList.remove('embla__dot--selected');
        dotNodes[emblaApi.selectedScrollSnap()].classList.add('embla__dot--selected');
        // scroll active dot into view
        const activeDot = dotNodes[emblaApi.selectedScrollSnap()];
        dotsNode.scrollTo({
          left: activeDot.offsetLeft - (dotsNode.clientWidth / 2) + (activeDot.offsetWidth / 2),
          behavior: 'smooth'
        });
        // fade logic
        const totalDots = dotNodes.length;
        if (totalDots > 15) {
          const activeIndex = emblaApi.selectedScrollSnap();
          let fadeLeft = 0;
          if (activeIndex > 6) {
            fadeLeft = Math.min(4, activeIndex - 6);
          }
          dotsNode.parentNode.setAttribute('data-fade-left', fadeLeft);
          let fadeRight = 0;
          const rightThreshold = totalDots - 6;
          if (activeIndex < rightThreshold) {
            fadeRight = Math.min(4, rightThreshold - 1 - activeIndex);
          }
          dotsNode.parentNode.setAttribute('data-fade-right', fadeRight);
        }
      };
      emblaApi
        .on('init', addDotBtnsWithClickHandlers)
        .on('reInit', addDotBtnsWithClickHandlers)
        .on('init', toggleDotBtnsActive)
        .on('reInit', toggleDotBtnsActive)
        .on('select', toggleDotBtnsActive)
      return () => dotsNode.innerHTML = '';
    };

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
    emblaApi.on('destroy', removeDotBtnsAndClickHandlers);

  });

});
